import {
  BrandAsset,
  NavigationItem,
  NavigationMenu,
  NavigationSidebar,
  NavigationTitle,
  TopNavRegionToggle,
} from "@certn/cascadia-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useEntitledRegions } from "../../hooks/useEntitledRegions";

export function BillingNavigation() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { canSwitchRegion } = useEntitledRegions();
  return (
    <NavigationSidebar
      toolbar={
        <>
          <BrandAsset height="27" width="92" brand="certn" type="full" />
          {canSwitchRegion && <TopNavRegionToggle />}
        </>
      }
    >
      <NavigationMenu>
        <NavigationItem
          key="back"
          icon="arrow_back"
          title={t("Back")}
          onPress={() => navigate("/")}
        />
      </NavigationMenu>
      <NavigationTitle style="global/heading-large" isSection>
        {t("Billing")}
      </NavigationTitle>
      <NavigationMenu>
        <NavigationItem
          title={t("Invoices")}
          onPress={() => navigate("/billing/invoices")}
          isActive={location.pathname.includes("/billing/invoices")}
          data-testid="invoices-navigation-button"
        />
        <NavigationItem
          title={t("Billing profiles")}
          onPress={() => navigate("/billing/billing-profiles")}
          isActive={location.pathname.includes("/billing/billing-profiles")}
          data-testid="billing-profiles-navigation-button"
        />
        <NavigationItem
          title={t("Payment profiles")}
          onPress={() => navigate("/billing/payment-profiles")}
          isActive={location.pathname.includes("/billing/payment-profiles")}
          data-testid="payment-profiles-navigation-button"
        />
      </NavigationMenu>
    </NavigationSidebar>
  );
}
